export const Time = {
  years: 365 * 24 * 60 * 60 * 1000,
  days: 24 * 60 * 60 * 1000,
  hours: 60 * 60 * 1000,
  mins: 60 * 1000,
  seconds: 1000,
  ms: 1,
};
